module.exports = __webpack_public_path__ + "static/media/icon_header_2x.48f8d2c9.png";